export { default as SvgColor } from './SvgColor';
